var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_971_60562)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_971_60562",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_971_60562)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_971_60562",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_971_60562)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7516 3.11767L8.486 1.16943C8.27862 1.11373 8.06251 1.09916 7.84961 1.12711C7.6367 1.15507 7.43174 1.22485 7.24576 1.33219C7.05979 1.43953 6.89632 1.58174 6.76562 1.75211C6.63492 1.92248 6.53955 2.1176 6.48405 2.32503L3.09619 14.9585C3.04037 15.1659 3.02598 15.3819 3.05387 15.5949C3.08176 15.8079 3.1516 16.0143 3.25895 16.2004C3.3663 16.3864 3.50925 16.5481 3.67968 16.6789C3.85012 16.8096 4.04426 16.9066 4.25179 16.9621L11.5174 18.9087C11.9362 19.0209 12.3821 18.9627 12.7576 18.7459C13.1332 18.5292 13.4071 18.1719 13.5194 17.7531L16.9072 5.11963C16.963 4.91219 16.9774 4.69623 16.9495 4.48323C16.9216 4.27024 16.8518 4.06546 16.7445 3.87939C16.6371 3.69332 16.4942 3.53 16.3237 3.39925C16.1533 3.26849 15.9591 3.17154 15.7516 3.11604V3.11767ZM11.2733 2.76285L12.5355 3.1014C12.5791 3.11045 12.6202 3.12789 12.6567 3.15348C12.6932 3.17907 12.7245 3.21318 12.7479 3.25114C12.7713 3.28909 12.787 3.33072 12.7935 3.37483C12.7999 3.41895 12.7969 3.4636 12.7853 3.50667C12.7738 3.54974 12.7535 3.5905 12.7259 3.62548C12.6983 3.66047 12.6642 3.68894 12.625 3.71012C12.5858 3.7313 12.5425 3.74526 12.498 3.74918C12.4536 3.7531 12.4085 3.74689 12.3662 3.73291L11.1032 3.39436C11.0612 3.38364 11.0214 3.36512 10.9868 3.33903C10.9522 3.31293 10.9233 3.28042 10.9014 3.243C10.8795 3.20557 10.8648 3.1639 10.859 3.12093C10.8533 3.07795 10.8567 3.03422 10.868 2.99235C10.8793 2.95048 10.8984 2.91108 10.925 2.87679C10.9515 2.84249 10.9849 2.81356 11.0226 2.79215C11.0603 2.77074 11.1016 2.75831 11.1447 2.75309C11.1877 2.74787 11.2315 2.75107 11.2733 2.76285ZM8.05143 17.3039C7.95745 17.2788 7.8731 17.2256 7.80892 17.1525C7.74473 17.0794 7.70366 16.9885 7.69091 16.8921C7.67817 16.7957 7.69431 16.6978 7.7373 16.6105C7.78029 16.5233 7.84838 16.4508 7.93261 16.4022C8.01685 16.3535 8.11306 16.3307 8.21012 16.3371C8.30718 16.3434 8.4007 16.3788 8.47786 16.438C8.55502 16.4972 8.61265 16.5786 8.64388 16.6707C8.67511 16.7629 8.67806 16.8616 8.65283 16.9556C8.61904 17.0814 8.53696 17.1883 8.42415 17.2534C8.31134 17.3186 8.17729 17.3375 8.05143 17.3039ZM12.2645 16.7407L4.68473 14.7062L7.73242 3.34065L15.3138 5.37353L12.2645 16.7407Z"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_971_60562"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon-download.e88b0cf1d94b0f9bedc2a8b76c827180.svg";
export { ForwardRef as ReactComponent };